<!-- =========================================================================================

  説明: ユーザーの検索条件を入力するダイアログコンポーネント
  作成者: Kokichi

========================================================================================== -->

<template>
  <div>
    <vs-prompt
      @accept="search"
      @cancel="cancel"
      @close="close"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
    >
      <div id="dialog-user-search-input-form">
        <span>社員名</span>
        <vs-input class="input-user-name" v-model="searchConditionCopy.name" />
        <span class="mt-4 mb-4">在籍状況</span>
        <ul class="center mt-4 mb-4">
          <li class="mr-4">
            <vs-radio v-model="searchConditionCopy.isRetirement" vs-value="all"
              >全て</vs-radio
            >
          </li>
          <li class="mr-4">
            <vs-radio
              v-model="searchConditionCopy.isRetirement"
              vs-value="currently"
              >在籍中</vs-radio
            >
          </li>
          <li class="mr-4">
            <vs-radio
              v-model="searchConditionCopy.isRetirement"
              vs-value="retirement"
              >退職済み</vs-radio
            >
          </li>
        </ul>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  props: {
    searchCondition: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      title: "社員の検索条件",
      acceptText: "検索",
      cancelText: "キャンセル",
      searchConditionCopy: this.searchCondition
    };
  },
  watch: {
    searchCondition(value) {
      this.searchConditionCopy = value;
    }
  },
  methods: {
    show() {
      this.showDialog = true;
    },
    search() {
      this.$emit('update:searchCondition', this.searchConditionCopy);
      this.$emit("searchUsers");
      this.showDialog = false;
    },
    close() {
      this.showDialog = false;
    },
    cancel() {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss">
#dialog-user-search-input-form {
  ul li {
    display: inline;
  }
  .input-user-name {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
</style>
